import { QueryResult } from "@apollo/client";
import { useQuery } from "@apollo/client/react/hooks/useQuery";

import { graphql } from "../../generated/gql";
import {
  ReadFontsQuery,
  ReadFontsQueryVariables,
} from "../../generated/gql/graphql";

const ReadFontsGQL = graphql(`
  query ReadFonts($query: FontQuery!) {
    fonts(query: $query) {
      items {
        id
        name
      }
    }
  }
`);

export function useFonts(
  variables: ReadFontsQueryVariables,
): QueryResult<ReadFontsQuery, ReadFontsQueryVariables> {
  return useQuery(ReadFontsGQL, {
    variables,
  });
}
